import { EmptyState, PageHeader } from "../components/ui";

export function NotFound() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
      <PageHeader kicker="Not found" before="Nothing " accent="here." />
      <EmptyState title="No such page." body="Pick a page from the menu." />
    </div>
  );
}
